import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// React icons
import { FaLinkedin } from 'react-icons/fa';
// core components

import { Link } from "gatsby";
import Collapse from '@material-ui/core/Collapse';

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import blogStyle from "assets/jss/material-kit-react/views/landingPageSections/blogStyle.jsx";

import whyCards from "data/why-cards.json";
import GirlAndBull from "components/Image/GirlAndBull.jsx";

class BlogSection extends React.Component {
  render() {
    const { classes } = this.props;
    const imageClasses = classNames(
      classes.imgRaised,
      classes.imgFluid
    );
    const member = whyCards[0];

    return (
      <div id="team" className={classes.section}>
        <GridContainer justify="center">
          <GridItem xs={12} lg={6}>
          <h2 className={classes.title}>
          Our Blog
          <br/>
          <small className={classes.smallTitle}>Our story. Our why.</small>
          </h2>
          <Link to="/blog">
            <h3>Find out more.</h3>
          </Link>
          </GridItem>
          <GridItem xs={12} sm={6}>
              <Card plain className={classes.card}>
                <GridItem xs={12} className={classes.itemGrid}>
                  <GirlAndBull style={{height: "300px"}}/>
                </GridItem>
                <h4 className={classes.cardTitle}>
                  <span dangerouslySetInnerHTML={{__html: `${member.title}`}}/>                  <br />
                </h4>
              </Card>
            </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(blogStyle)(BlogSection);